var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: 18,
    width: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "ellipse-1",
    opacity: 1,
    rx: 9,
    ry: 9,
    cx: 9,
    cy: 9
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "ellipse-2",
    opacity: 1,
    rx: 1.5,
    ry: 1.5,
    cx: 12.5,
    cy: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-3",
    opacity: 1,
    fillRule: "evenodd",
    d: "M15.888424159937513,11.211218836565097 C15.779834714077907,11.078254847645429 15.60853868680642,11 15.426536657830468,11 L3.573463342169531,11 C3.3914613131935765,11 3.2201652859220893,11.078254847645429 3.111575840062486,11.211218836565097 C3.0037511086103446,11.344182825484765 2.9716331034969405,11.515235457063712 3.0259278264267424,11.673130193905816 C3.912231824675195,14.261080332409971 6.514554953268368,16 9.499999999999998,16 C12.48544504673163,16 15.087768175324804,14.261080332409971 15.974072173573258,11.673130193905816 C16.028366896503055,11.515927977839333 15.996248891389651,11.344182825484763 15.888424159937513,11.211218836565097Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-4",
    opacity: 1,
    fillRule: "evenodd",
    d: "M6.5,7 L3.5,7 C3.224,7 3,6.776 3,6.5 C3,6.224 3.224,6 3.5,6 L6.5,6 C6.776,6 7,6.224 7,6.5 C7,6.776 6.776,7 6.5,7Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ellipse-1",
    fill: "rgb(255,213,79)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ellipse-2",
    fill: "rgb(109,76,65)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3",
    fill: "rgb(229,57,53)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-4",
    fill: "rgb(109,76,65)",
    fillOpacity: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWink);
export default __webpack_public_path__ + "static/media/wink.4b0f0be43b586b96a70fd2a1df5bcbd9.svg";
export { ForwardRef as ReactComponent };